import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { ProjectPool } from '../../shared/models/project-pool';
import { TalentPool } from 'mojo-talent-pools';
import { BarChartData } from '@app/shared/models/bar-chart';

export const loadProjects = createAction('[Projects] Load Projects');

export const loadProjectsSuccess = createAction(
  '[Projects] Load Projects Success',
  props<{ payload: { projects: ProjectPool[] } }>(),
);

export const loadProjectsError = createAction(
  '[Projects] Load Projects Error',
  props<{ error: HttpErrorResponse }>(),
);

export const updateProject = createAction(
  '[Projects] Update Project',
  props<{ payload: { project: ProjectPool; reloadCandidates?: boolean } }>(),
);

export const updateProjectSuccess = createAction(
  '[Projects] Update Project Success',
  props<{ payload: { project: ProjectPool } }>(),
);

export const updateProjectNameFail = createAction(
  '[Projects] Update Project Name Error',
  props<{ error: HttpErrorResponse }>(),
);

export const addCandidateToProject = createAction(
  '[Projects] Add Candidate To Project',
  props<{ payload: { projectId: number; candidateId: string } }>(),
);

export const addCandidateToProjectSuccess = createAction(
  '[Projects] Add Candidate To Project Success',
  props<{ payload: { projectId: number; candidateId: string } }>(),
);

export const addCandidateToProjectError = createAction(
  '[Projects] Add Candidate To Project Error',
  props<{ error: HttpErrorResponse }>(),
);

export const deleteProject = createAction(
  '[Projects] Delete Project',
  props<{ payload: { projectId: number } }>(),
);

export const deleteProjectSuccess = createAction(
  '[Projects] Delete Project Success',
  props<{ payload: { projectId: number } }>(),
);

export const deleteProjectError = createAction(
  '[Projects] Delete Project Error',
  props<{ error: HttpErrorResponse }>(),
);

export const saveProjectAndAssignCandidate = createAction(
  '[Projects] Create Project',
  props<{ payload: { candidateId: string; talentPool: Partial<TalentPool> } }>(),
);

export const saveProjectAndAssignCandidateSuccess = createAction(
  '[Projects] Create Project Success',
  props<{ payload: { project: ProjectPool } }>(),
);

export const saveProjectAndAssignCandidateError = createAction(
  '[Projects] Create Project Error',
  props<{ error: HttpErrorResponse }>(),
);

export const assignProjectSelectedId = createAction(
  '[Projects] Assign Project Selected Id',
  props<{ payload: { id: number } }>(),
);

export const loadCandidatesForSelectedProject = createAction(
  '[Projects] Load Candidates For Selected Project',
);

export const setIsLikedTabActive = createAction(
  '[Projects] Set Is Liked Tab Active',
  props<{ payload: { isLikedTabActive: boolean } }>(),
);

export const deleteCandidateFromTheProject = createAction(
  '[Projects] Delete Candidates From The Project',
  props<{ payload: { projectId: number; candidateIds: string[] } }>(),
);

export const deleteCandidateFromTheProjectError = createAction(
  '[Projects] Delete Candidates From The Project Error',
  props<{ error: HttpErrorResponse }>(),
);

export const projectChangeExternalCandidateStatusFastr = createAction(
  '[Project Page] Project Change External Candidate Status fartr',
  props<{
    candidateId: string;
    status: string | null;
    talentPoolId?: number;
  }>(),
);

export const projectChangeExternalCandidateStatusFastrSuccess = createAction(
  '[Project Page] Project Change External Candidate Status fartr Success',
);

export const projectChangeExternalCandidateStatusFastrFailure = createAction(
  '[Project Page] Project Change External Candidate Status fartr Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const loadBarChartData = createAction(
  '[Project Page] Load Bar Chart Data',
  props<{ talentPoolId: number }>(),
);

export const loadBarChartDataSuccess = createAction(
  '[Project Page] Load Bar Chart Data Success',
  props<{ data: BarChartData }>(),
);

export const loadBarChartDataFailure = createAction(
  '[Project Page] Load Bar Chart Data Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const resetBarChartData = createAction('[Project Page] Reset Bar Chart Data');
